import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconQuestionmarkCircle2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"questionmark-circle-2, faq, help, questionaire"} maskId="square-filled-radius-0-stroke-1-IconQuestionmarkCircle2"><path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM9 7H15V10.7831L12.5 12.2831V15H11.5V11.7169L14 10.2169V8H10V10H9V7ZM12.5 16V17.01H11.5V16H12.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconQuestionmarkCircle2;
